<h5 translate>list-sessions-with-pending-retake-requests.component.title</h5>

<lv-claims-list
  sessionType="pendingRetake"
  [sessions]="sessions$ | async"
  claimItemType="retakeRequest"
></lv-claims-list>
